import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Editore } from '../../../models/Editore';
import { BookService } from './../../../services/book.service';

@Component({
  selector: 'app-editore-selector',
  templateUrl: './editore-selector.component.html',
  styleUrls: ['./editore-selector.component.css'],
  providers: [
    BookService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditoreSelectorComponent),
      multi: true
    }
  ]
})
export class EditoreSelectorComponent implements OnInit {

  items: Observable<any>;
  selected: Editore;
  loading: boolean;

  @Input() placeholder: string;
  @Input() required: boolean = false;
  @Output() notify: EventEmitter<Editore> = new EventEmitter<Editore>();

  constructor(private bookService: BookService) { }

  onChange(e: Editore) {
    this.notify.emit(e);
    this.propagateChange(e);
    // console.log('onChange Editore -> propagateChange', e)
    // this.propagateChange(this.toModel());
  }

  set _count(c: number) {
    // console.log('_count', c)
  }

  ngOnInit() { }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Editore) {
    // console.log('======= ************ writeValue', this.placeholder, obj)
    this.loading = true;
    this.items = this.bookService.readEditore()
      .map(result => {
        this.loading = false;
        if (result.success) {
          if (obj) {
            // console.log(result.items)
            // console.log(obj.codice)
            this.selected = result.items.find(p => p.codice == obj.codice);
            if (!this.selected) {
              //AH OH.... ORRIBILE ma a volte nell'onix nel codice c'è la descrizione
              this.selected = result.items.find(p => p.descrizione == obj.codice);
            }
            //console.log('======= ************ MATCH', this.placeholder, this.selected)
            this.propagateChange(this.selected);
          }
          return result.items;
        }
      })
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/editore/editore-selector/editore-selector.component.ts